import React, { useState, useEffect } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { useAuth } from "../../../components/context/AuthContext";
import { updateProfile, getProfile } from "../../../api/authApi";
import Layout from "../../layout/Layout"; // yeni Layout'u kullan
import "../../styles/profilePageStyle.css";

function ProfilePage() {
  const { user, login } = useAuth();

  const [profileData, setProfileData] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (!user?._id) return;

    const fetchProfile = async () => {
      try {
        const res = await getProfile(user._id);
        const data = res?.data?.data || res?.data || {};
        setProfileData({
          name: data.name || "",
          surname: data.surname || "",
          email: data.email || "",
          phone: data.phone || "",
        });
      } catch (err) {
        console.error("Profil verisi çekilemedi:", err);
      }
    };

    fetchProfile();
  }, [user]);

  if (!user) return null;

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setProfileData((prev) => ({
      ...prev,
      [name]: type === "number" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        userId: user._id,
        ...profileData,
        phone: Number(profileData.phone),
      };
      const res = await updateProfile(payload);
      const newToken = res?.data?.data;
      if (newToken) {
        login(newToken);
      }
      alert("Profil başarıyla güncellendi!");
    } catch (error) {
      console.log(error);
      alert("Profil güncellenirken hata oluştu.");
    }
  };

  return (
    <Layout>
      <Card
        className="profile-container"
        style={{
          maxWidth: 480,
          margin: "32px auto",
          borderRadius: 16,
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        }}
      >
        <Card.Body>
          <h2 className="profile-header mb-4">Profil Bilgileri</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Ad</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={profileData.name}
                onChange={handleChange}
                placeholder="Adınız"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Soyad</Form.Label>
              <Form.Control
                type="text"
                name="surname"
                value={profileData.surname}
                onChange={handleChange}
                placeholder="Soyadınız"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>E-posta</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={profileData.email}
                onChange={handleChange}
                placeholder="E-posta adresiniz"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Telefon</Form.Label>
              <Form.Control
                type="number"
                name="phone"
                value={profileData.phone}
                onChange={handleChange}
                placeholder="Telefon numaranız"
              />
            </Form.Group>
            <div style={{ textAlign: "right" }}>
              <Button type="submit" variant="primary">
                Kaydet
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Layout>
  );
}

export default ProfilePage;
